const authStyles = {
  cardBox: {
    borderRadius: "17px",
    position: "relative",
    padding: "25px 24px",
    boxShadow: "0px 29px 54px 0px #46268214 !important",
    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      borderRadius: "17px",
      padding: "2px",
      background:
        "linear-gradient(122.13deg, rgba(193, 29, 133, 0.11) -0.65%, rgba(173, 200, 4, 0.11) 53.02%, rgba(70, 38, 130, 0.11) 101.19%)",
      WebkitMask:
        "linear-gradient(white 0 0) content-box, linear-gradient(white 0 0)",
      WebkitMaskComposite: "destination-out",
      pointerEvents: "none",
    },
  },
  btnStyle: {
    cursor: "pointer",
    fontWeight: "bolder",
    color: "#7551D0",
    marginLeft: 4,
    marginRight: 4,
    textDecoration: "underline",
  },
  registredBox: {
    height: "90vh",
    maxWidth: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding:2
  },
  registredInnerBox: {
    padding: 3,
    border: "1px solid #47556940",
    boxShadow: "4px 8px 20px rgba(0, 0, 0, 0.05)",
    borderRadius: "16px",
    textAlign: "center",
  },
};
export default authStyles;
